export const impersonate = (userId: number) =>
  `/api/Administration/Impersonate?userId=${userId}`;

export const isImpersonating = () => `/api/Administration/IsImpersonating`;

export const cancelImpersonization = () =>
  `/api/Administration/CancelImpersonization`;
